// dimmed 처리
export function showDimmed() {
    $(".clickable-dimmed").removeClass("dp-none");
}
export function showNonClickableDimmed() {
    $(".non-clickable-dimmed").removeClass("dp-none");
}

export function hideDimmed() {
    $(".dimmed").addClass("dp-none");
}

//  메뉴 보이기/ 숨기기
export function showMenu() {
    showDimmed();
    //$(".lnb-menu").removeClass("dp-none");            
    $(".lnb-menu").show(200);
}
export function hideMenu() {
    hideDimmed();
    $(".lnb-menu").hide(200);
}
//팝업 열기
export function openPop(pop) {
    showDimmed();
    var popName = "pop-" + pop;
    $("." + popName).slideDown(200);
}
//팝업 닫기
export function closePop() {
    hideDimmed();
    $(".pop").slideUp(200);
}
//알림 팝업 열기
export function openPopAlert(pop, enableDimmedClick = true) {
    $('body').css('overflow','hidden')
    // console.log($('body'));
    if (enableDimmedClick) {
        showDimmed();
    } else {
        showNonClickableDimmed();
    }
    if (pop == "") {
        pop = "alert";
    }
    var popName = "pop-" + pop;
    const elems = $("." + popName);
    $(elems[elems.length - 1]).show();
}
//알림 팝업 닫기
export function closePopAlert() {
    if ($(".lnb-menu").css("display") === "none") {
        hideDimmed();
    }
    $(".pop-alert").hide();
    $('body').css('overflow','')
}

//팝업 바코드 확대
export function expandMemBar() {
    $(".pop-order").addClass("expand");
}
//팝업 바코드 축소
export function downsizeMemBar() {
    $(".pop-order").removeClass("expand");
}

// 버튼 on/off
export function toggleBtn() {
    $(".btn").toggleClass("active");
};

//체크박스 전체 선택
export function toggleChkAll() {
    if($(".btn-chk-all").hasClass("active")){
        $(".btn-chk-all").removeClass("active");
        $(".chk").prop( "checked", false );
        $(".btn-full").removeClass("active");
    }else{
        $(".btn-chk-all").addClass("active");
        $(".chk").prop( "checked", true );
    }   $(".btn-full").addClass("active");
}
//별도로 버튼 영역 최하단으로 위치할때
//margin 값 계산
//position:fixed 사용하지 않는 이유는
//키패드로 입력시 화면을 가리는 것 방지
$(document).ready(function() {
    var mainH = $(".mainbox").height();
    var contentH = $(".contents").height();
    var bottomH = $(".bottombox").height();
    var marginTop = mainH - contentH - bottomH;
    $(".bottombox").css("margin-top", marginTop);
});
//lnb load
$(document).ready(function(){
    $("#lnb").load("/gongcha/html/lnb.html");
})


// WEBPACK FOOTER //
// ./src/js/commonJQuery.js